export function videoOnScroll() {
    const $videos = $(".has-video-animation");
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const $video = $(entry.target);
            const $videoElement = $video.find("video").get(0);
            if (entry.isIntersecting && $videoElement) {
                $videoElement.play();
            } else if ($videoElement) {
                $videoElement.pause();
            }
        });
    });
    $videos.each(function () {
        observer.observe(this);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/videoOnScroll.js